import React, {ForwardRefRenderFunction, useContext} from 'react';
import "./Select.scss";
import styled from "styled-components";
import {Theme} from "../../../models/theme.model";
import {ThemeContext} from "../../../context/ThemeContext";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
}

const StyledSelect = styled.select`
      &&& {
        border-color: ${props => props.theme.branding_color}
      }
`;

export const Select = React.forwardRef<ForwardRefRenderFunction<HTMLSelectElement>, SelectProps>((props, ref: any) => {
        const theme: Theme = useContext(ThemeContext).theme;
        const {...selectProps} = props

        return (
            <StyledSelect theme={theme} ref={ref} {...selectProps} className={'select'}/>
        );
    }
)
